import { createSlice } from '@reduxjs/toolkit';
import { loadKpiConfig, loadKpiData, loadRagThresholds } from '../actions/Beacon4BlendedActions';

const initialState = {
	configs:    [],
	series:     [],
	thresholds: [],
	loading:    false,
	error:      null,
};

const kpiDataSlice = createSlice({
	name: 'kpiData',
	initialState,
	reducers: {
		// Explicitly clear series when polygon changes — prevents stale data flash
		clearSeries: (state) => {
			state.series = [];
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(loadKpiConfig.pending,      (state) => { state.loading = true;  state.error = null; })
			.addCase(loadKpiConfig.fulfilled,     (state, action) => {
				state.loading = false;
				state.configs = action.payload ?? [];
			})
			.addCase(loadKpiConfig.rejected,     (state, action) => { state.loading = false; state.error = action.payload; })

			.addCase(loadKpiData.pending,        (state) => { state.loading = true; state.error = null; state.series = []; })
			.addCase(loadKpiData.fulfilled,       (state, action) => {
				state.loading = false;
				state.configs = action.payload.configs ?? [];
				state.series  = action.payload.series  ?? [];
			})
			.addCase(loadKpiData.rejected,       (state, action) => { state.loading = false; state.error = action.payload; })

			.addCase(loadRagThresholds.fulfilled, (state, action) => { state.thresholds = action.payload ?? []; });
	},
});

export const { clearSeries } = kpiDataSlice.actions;
export default kpiDataSlice.reducer;